import { Button, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const StyledRTEContainer = styled.div`
  .ql-container {
    min-height: 120px !important;
  }
  .ql-editor {
    min-height: 120px !important;
  }
`

export const NextVisitSlotSelectorContainer = muiStyled('div')(
  ({ theme }) => `
  height: 400px;
  max-height: 400px;
  padding: 20px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  .next-visit-calendar {
    height: 100%;
    width: 100%;
  }
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(139, 92, 246, 0.3);
    border-radius: 10px;
    &:hover {
      background: rgba(139, 92, 246, 0.5);
    }
  }
`,
)

export const NextVisitSlotSelectorButton = muiStyled(Button)(
  ({ theme }) => `
  padding: 8px px;
  background-color: #0000;
  color:rgb(46, 46, 46);
  border: 1px solid rgb(199, 199, 199);
  border-radius: 8px;
  transition: all 0.3s ${theme.transitions.easing.quickInOut};
  &:hover {
    background-color: #e2dfff;
    transform: translateY(-1px);
    border: 1px solid #a167f4;
    color:  #a167f4;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    .time-slot-text {
      font-weight: 600;
    }
  }
`,
)

export const DateSelectorCard = muiStyled(Button, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ theme, isSelected }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '100px',
  padding: '16px',
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: isSelected ? '#e2dfff' : '#0000',
  color: isSelected ? '#a167f4' : 'rgb(46, 46, 46)',
  border: isSelected ? '1px solid #a167f4' : '1px solid #e0e0e0',
  borderRadius: '8px',
  transition: `all 0.3s ${theme.transitions.easing.quickInOut}`,
  '&:hover': {
    backgroundColor: isSelected ? 'rgb(208, 203, 252)' : '#f5f5f5',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
}))

export const NextVisitSlotSelectorGridContainer = muiStyled('div')(
  ({ theme }) => `
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  gap: 8px;
  @media(min-width: ${theme.breakpoints.values.md}px) {
    grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  }
  @media(min-width: ${theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  }
`,
)
